<template>
    <div>
        <legend class="font-weight-bold mb-2">
            {{idType}}
        </legend>
        <div class="row">
            <div class="col-md-9">
                <div class="form-group" v-if="numbersOnly">
                    <input class="form-control" type="number" v-model="customId" min="0">
                </div>
                <div class="form-group" v-else>
                    <input class="form-control" type="text" v-model="customId">
                </div>
            </div>
            <div class="col-md-3">
                <button @click.prevent="addId" class="btn btn-primary"><i class="fa fa-plus"></i> Add {{idType}} </button>
            </div>
        </div>
        <div v-if="selectedIdsClone.length" class="row m-2">
            <div v-for="(custom_id, index) in selectedIdsClone">
                                <span class="badge badge-pill" :class="[customId === custom_id ? 'badge-warning' : 'badge-primary']">
                                    {{ custom_id }}&nbsp
                                    <i class="fas fa-times cursor-pointer text-white" @click.prevent="removeId(index)"></i>
                                </span>
            </div>
        </div>
        <div v-else>
            <div class="alert alert-warning" role="alert" >
                {{emptyAlert}}
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props     : {
            idType: {required: true},
            selectedIds: {required: true},
            numbersOnly: {default: true},
            emptyAlert: {default: 'If no Office IDs are selected all incoming Office IDs for this instance/connection will be processed.'}

        },
        data      : () => ({
            customId: '',
            selectedIdsClone: [],

        }),
        computed: {

        },
        watch     : {
            selectedIds: {
                immediate: true,
                handler() {
                    this.selectedIdsClone = this.selectedIds;
                }
            }
        },
        methods: {
            addId(){
                if(this.customId === null || this.customId.match(/^ *$/) !== null){
                    return;
                }
                if (!this.selectedIds.includes(this.customId)){
                    if(this.numbersOnly && this.customId <= 0) {
                        return;
                    }
                    this.$emit('addId', this.customId);
                    this.customId = '';
                }
            },

            removeId(id_index){
                this.$emit('removeIdIndex', id_index);
            },
        }
    }
</script>
